import { axios } from '@Root/API'

export const getInitial = () => {
	return axios.get(`data-for-create-role`)
}
